import { MutationTree } from 'vuex';
import { State } from './overview.store';
import { initialState } from '@/store/modules/channel/overview/overview.store';

const mutations: MutationTree<State> = {
  setCurrentChannel(state: State, data: {}) {
    state.currentChannel = data;
  },
  setChannels(state: State, data: {}[]) {
    state.channels = data;
  },
  setTotalChannels(state: State, data: Number) {
    state.totalChannels = data;
  },
  setSearchTotalChannels(state: State, data: Number) {
    state.searchTotalChannels = data;
  },
  setShowAddChannel(state: State, data: Boolean) {
    state.showAddChannel = data;
  },
  setShowDeleteChannel(state: State, data: Boolean) {
    state.showDeleteChannel = data;
  },
  setRefreshChannels(state: State, data: Boolean) {
    state.refreshChannels = data;
  },
  setAlertRuleChannels(state: State, data: {}[]) {
    state.alertRuleChannels = data;
  },
  setAlertGroupRuleChannels(state: State, data: Array<string>) {
    state.alertGroupRuleChannels = data;
  },
  setTotalAlertRuleChannels(state: State, data: Number) {
    state.totalAlertRuleChannels = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
